// Resolves a CSS custom-property reference like `var(--chart-1)` to its concrete value, since
// chart.js draws on canvas and cannot read CSS variables. Mirrors the prototype's resolveColor.
export function resolveCssColor(value: string): string {
  if (typeof window === 'undefined') return value;
  const match = value.match(/var\((--[^)]+)\)/);
  if (!match) return value;
  const resolved = getComputedStyle(document.documentElement).getPropertyValue(match[1]).trim();
  return resolved || value;
}

// Shared font for axis/legend labels (matches prototype Chart.js config).
export const CHART_FONT_FAMILY = "'Pretendard', sans-serif";
